"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Encryption_1 = require("./_Encryption");
var _Grants_1 = require("./_Grants");
var _Tagging_1 = require("./_Tagging");
var _UserMetadata_1 = require("./_UserMetadata");
exports._S3Location = {
    type: "structure",
    required: ["BucketName", "Prefix"],
    members: {
        BucketName: {
            shape: {
                type: "string"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Encryption: {
            shape: _Encryption_1._Encryption
        },
        CannedACL: {
            shape: {
                type: "string"
            }
        },
        AccessControlList: {
            shape: _Grants_1._Grants
        },
        Tagging: {
            shape: _Tagging_1._Tagging
        },
        UserMetadata: {
            shape: _UserMetadata_1._UserMetadata
        },
        StorageClass: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_S3Location.js.map